import Icon from 'gu-ui-kit/Icon'
import React, { lazy } from 'react'
import { ROUTES } from 'constants/routes'
import { ROUTE_ACCESS, withAccess } from 'utils/routeAccess'
const AuthLogin = lazy(() => import(/* webpackChunkName: "page-auth-login" */ 'modules/Auth/Login'))
const AuthRegistration = lazy(() =>
  import(/* webpackChunkName: "page-auth-registration" */ 'modules/Auth/Registration'),
)
const AuthRecover = lazy(() =>
  import(/* webpackChunkName: "page-auth-recover" */ 'modules/Auth/Recover'),
)
const AuthRecoverSent = lazy(() =>
  import(/* webpackChunkName: "page-auth-recover" */ 'modules/Auth/RecoverSent'),
)
const AuthDoubleFA = lazy(() =>
  import(/* webpackChunkName: "page-auth-2fa" */ 'modules/Auth/DoubleFA'),
)
const AuthAdmitadOauth = lazy(() =>
  import(/* webpackChunkName: "page-auth-admitad" */ 'modules/Auth/AdmitadOauth'),
)
const AuthActivation = lazy(() =>
  import(/* webpackChunkName: "page-auth-activation" */ 'modules/Auth/Activation'),
)
const AuthRecoverPassword = lazy(() =>
  import(/* webpackChunkName: "page-auth-recover" */ 'modules/Auth/RecoverPassword'),
)

const ServicesList = lazy(() =>
  import(/* webpackChunkName: "page-services-list" */ 'modules/Services/NetworksList'),
)
const ServicesNetwork = lazy(() =>
  import(/* webpackChunkName: "page-services-network" */ 'modules/Services/Network'),
)
const ServicesNetworkMediaPlanner = lazy(() =>
  import(/* webpackChunkName: "page-services-media-planner" */ 'modules/MediaPlanner/MediaPlanner'),
)
const ServicesNetworkAccount = lazy(() =>
  import(/* webpackChunkName: "page-services-account" */ 'modules/Services/Account'),
)
const ServicesNetworkAccountRefund = lazy(() =>
  import(/* webpackChunkName: "page-services-refund" */ 'modules/Services/Refund'),
)
const ServicesNetworkAccountAccess = lazy(() =>
  import(/* webpackChunkName: "page-services-access" */ 'modules/Services/Access/List'),
)
const ServicesNetworkAccountAccessCreate = lazy(() =>
  import(/* webpackChunkName: "page-services-access" */ 'modules/Services/Access/Create'),
)
const ServicesNetworkAccountCampaigns = lazy(() =>
  import(/* webpackChunkName: "page-services-campaigns" */ 'modules/Services/Campaigns/Main'),
)
const ServicesNetworkAccountCampaignCreate = lazy(() =>
  import(/* webpackChunkName: "page-services-campaigns" */ 'modules/Services/Campaigns/Create'),
)
const ServicesNetworkAccountCampaignStart = lazy(() =>
  import(/* webpackChunkName: "page-services-campaigns" */ 'modules/Services/Campaigns/Start'),
)
const ServicesNetworkAccountCreate = lazy(() =>
  import(/* webpackChunkName: "page-services-account-create" */ 'modules/Services/AccountCreate'),
)
const ServicesNetworkCampaignsEditor = lazy(() =>
  import(
    /* webpackChunkName: "page-services-campaigns-editor" */ 'modules/Services/CampaignsEditor'
  ),
)

const Agency = lazy(() => import(/* webpackChunkName: "page-agency" */ 'modules/Agency'))
const AddClient = lazy(() =>
  import(/* webpackChunkName: "page-agency-add-client" */ 'modules/Agency/AddClient'),
)
const AddAgency = lazy(() =>
  import(/* webpackChunkName: "page-agency-add-agency" */ 'modules/Agency/AddAgency'),
)
const Transfer = lazy(() =>
  import(/* webpackChunkName: "page-agency-transfer" */ 'modules/Agency/Transfer'),
)

const ReferralList = lazy(() =>
  import(/* webpackChunkName: "page-referral-list" */ 'modules/Referrals/ReferralsList'),
)
const ReferralPayout = lazy(() =>
  import(/* webpackChunkName: "page-referral-payout" */ 'modules/Referrals/PayoutCreate'),
)
const ReferralInvoices = lazy(() =>
  import(
    /* webpackChunkName: "page-referral-profiles" */ 'modules/Referrals/PayoutProfiles/Invoices'
  ),
)
const PayoutProfiles = lazy(() =>
  import(/* webpackChunkName: "page-referral-profiles" */ 'modules/Referrals/PayoutProfiles/List'),
)
const PayoutProfilesCreate = lazy(() =>
  import(
    /* webpackChunkName: "page-referral-profiles" */ 'modules/Referrals/PayoutProfiles/Create'
  ),
)
const StatisticsMain = lazy(() =>
  import(/* webpackChunkName: "page-statistics-main" */ 'modules/Statistics/Main'),
)
const StatisticsAccount = lazy(() =>
  import(/* webpackChunkName: "page-statistics-account" */ 'modules/Statistics/Account'),
)
// const StatisticsAccountConnect = lazy(() => import('modules/Statistics/subcomponents/AccountConnect'))
const StatisticsCampaign = lazy(() =>
  import(/* webpackChunkName: "page-statistics-campaign" */ 'modules/Statistics/Campaign'),
)

const Settings = lazy(() =>
  import(/* webpackChunkName: "page-user-settings" */ 'modules/User/Settings'),
)
const Password = lazy(() =>
  import(/* webpackChunkName: "page-user-security" */ 'modules/User/Security/Password'),
)
const DoubleFA = lazy(() =>
  import(/* webpackChunkName: "page-user-security" */ 'modules/User/Security/2fa'),
)
const DoubleFASetup = lazy(() =>
  import(/* webpackChunkName: "page-user-security" */ 'modules/User/Security/2fa/Setup'),
)

const AccountReplenish = lazy(() =>
  import(/* webpackChunkName: "page-finance-billing" */ 'modules/Billing/AccountReplenish'),
)
const DepositReplenish = lazy(() =>
  import(/* webpackChunkName: "page-finance-billing" */ 'modules/Billing/DepositReplenish'),
)
const AccountsReplenish = lazy(() =>
  import(/* webpackChunkName: "page-finance-billing" */ 'modules/Billing/AccountsReplenish'),
)
const DepositCreationFee = lazy(() =>
  import(/* webpackChunkName: "page-finance-billing" */ 'modules/Billing/DepositCreationFee'),
)
const BillingPaymentOrder = lazy(() =>
  import(/* webpackChunkName: "page-finance-payment-order" */ 'modules/Billing/PaymentOrder'),
)

const AutoReplenish = lazy(() =>
  import(/* webpackChunkName: "page-services-autoreplenish" */ 'modules/AutoReplenish'),
)
const OauthAuth = lazy(() => import(/* webpackChunkName: "page-oauth-auth" */ 'modules/Oauth/Auth'))
const OauthCode = lazy(() => import(/* webpackChunkName: "page-oauth-code" */ 'modules/Oauth/Code'))

const Wallets = lazy(() =>
  import(/* webpackChunkName: "page-finance-wallets" */ 'modules/Finance/Wallets'),
)
const WalletsRedirect = lazy(() =>
  import(/* webpackChunkName: "page-finance-wallets" */ 'modules/Finance/Wallets/WalletsRedirect'),
)
const PromisedPayment = lazy(() =>
  import(/* webpackChunkName: "page-finance-promised" */ 'modules/Finance/PromisedPayment'),
)
const PromisedPaymentRequest = lazy(() =>
  import(/* webpackChunkName: "page-finance-promised" */ 'modules/Finance/PromisedPayment/Request'),
)
const Invoices = lazy(() =>
  import(/* webpackChunkName: "page-finance-invoices" */ 'modules/Finance/Invoices'),
)
const PaymentProfiles = lazy(() =>
  import(/* webpackChunkName: "page-finance-payment-profiles" */ 'modules/Finance/PaymentProfiles'),
)
const PaymentProfilesCreate = lazy(() =>
  import(
    /* webpackChunkName: "page-finance-payment-profiles" */ 'modules/Finance/PaymentProfiles/Create'
  ),
)

const PaymentsReturnUrl = lazy(() =>
  import(/* webpackChunkName: "page-return-url-payments" */ 'modules/ReturnUrl/Payments'),
)
const TargetMailCode = lazy(() =>
  import(/* webpackChunkName: "page-return-url-targetmail" */ 'modules/ReturnUrl/TargetMailCode'),
)
const VkCode = lazy(() =>
  import(/* webpackChunkName: "page-return-url-vk" */ 'modules/ReturnUrl/VkCode'),
)
const VkAdsMarketCode = lazy(() =>
  import(
    /* webpackChunkName: "page-return-url-vkads-market" */ 'modules/ReturnUrl/VkAdsMarketCode'
  ),
)
const VkAdsCode = lazy(() =>
  import(/* webpackChunkName: "page-return-url-vkads" */ 'modules/ReturnUrl/VkAdsCode'),
)
const TicketOpener = lazy(() =>
  import(/* webpackChunkName: "page-tickets" */ 'components/TicketsPanel/TicketOpener'),
)
const LocalPay = lazy(() =>
  import(/* webpackChunkName: "page-finance-local-pay" */ 'modules/LocalPay'),
)
const ReferralClients = lazy(() =>
  import(/* webpackChunkName: "page-referral-clients" */ 'modules/Referrals/ReferralClients'),
)
const ReferralLinks = lazy(() =>
  import(/* webpackChunkName: "page-referral-links" */ 'modules/Referrals/ReferralLinks'),
)
const ReferralLinksCreate = lazy(() =>
  import(
    /* webpackChunkName: "page-referral-links" */ 'modules/Referrals/ReferralLinks/CreateLink'
  ),
)
const ReferralLinksEdit = lazy(() =>
  import(/* webpackChunkName: "page-referral-links" */ 'modules/Referrals/ReferralLinks/EditLink'),
)
const YandexAdsCode = lazy(() =>
  import(/* webpackChunkName: "page-return-url-yandex" */ 'modules/ReturnUrl/YandexAdsCode'),
)

// FAQ
const FaqCategories = lazy(() =>
  import(/* webpackChunkName: "page-faq" */ 'modules/Faq/Categories'),
)
const FaqCategory = lazy(() => import(/* webpackChunkName: "page-faq" */ 'modules/Faq/Category'))
const FaqArticle = lazy(() => import(/* webpackChunkName: "page-faq" */ 'modules/Faq/Article'))

const ServicesNetworkAccountAdvertiserInfoEdit = lazy(() =>
  import(
    /* webpackChunkName: "page-services-advertiser-edit" */ 'modules/Services/AccountAdvertiserInfoEdit'
  ),
)
const ServicesNetworkCampaignsEditorDefault = lazy(() =>
  import(
    /* webpackChunkName: "page-services-campaigns-editor" */ 'modules/Services/CampaignsEditor/Default'
  ),
)

const BankCards = lazy(() =>
  import(/* webpackChunkName: "page-virtual-cards" */ 'modules/BankCards'),
)
const BankCardsCreateCard = lazy(() =>
  import(/* webpackChunkName: "page-virtual-cards" */ 'modules/BankCards/CreateCard'),
)
const BankCardsCard = lazy(() =>
  import(/* webpackChunkName: "page-virtual-cards" */ 'modules/BankCards/Card'),
)
const BankCardsReplenish = lazy(() =>
  import(/* webpackChunkName: "page-finance-billing" */ 'modules/Billing/BankCardsReplenish'),
)
const BankCardsCreationFee = lazy(() =>
  import(/* webpackChunkName: "page-finance-billing" */ 'modules/Billing/BankCardsCreationFee'),
)

const publicRoutesList = [
  {
    path: ROUTES.PAYMENT_ORDER,
    component: BillingPaymentOrder,
    exact: true,
    key: 'payment-order',
    domain: 'finance',
    layout: 'custom',
  },
]

const guestRoutesList = [
  {
    path: ROUTES.AUTH_REGISTRATION,
    component: AuthRegistration,
    exact: true,
    key: 'registration',
    layout: 'auth',
    domain: 'auth',
  },
  {
    path: ROUTES.AUTH_LOGIN,
    component: AuthLogin,
    exact: true,
    key: 'login',
    layout: 'auth',
  },
  {
    path: ROUTES.AUTH_ACTIVATION,
    component: AuthActivation,
    exact: true,
    key: 'activation',
    layout: 'auth',
  },
  {
    path: ROUTES.AUTH_RECOVER_WITH_EMAIL,
    component: AuthRecover,
    exact: true,
    key: 'recover-with-email',
    layout: 'auth',
  },
  {
    path: ROUTES.AUTH_RECOVER,
    component: AuthRecover,
    exact: true,
    key: 'recover',
    layout: 'auth',
  },
  {
    path: ROUTES.AUTH_RECOVER_SENT,
    component: AuthRecoverSent,
    exact: true,
    key: 'recover-sent',
    layout: 'auth',
  },
  {
    path: ROUTES.AUTH_RECOVER_SET_PASSWORD,
    component: AuthRecoverPassword,
    exact: true,
    key: 'password-recover',
    layout: 'auth',
  },
  {
    path: ROUTES.AUTH_LOGIN_2FA,
    component: AuthDoubleFA,
    exact: true,
    key: '2fa',
    layout: 'auth',
  },
  {
    path: ROUTES.AUTH_ADMITAD_CHECK,
    component: AuthAdmitadOauth,
    exact: true,
    key: 'admitad-oauth',
  },
]

const privateRoutesList = [
  {
    path: ROUTES.LOCAL_PAY,
    component: LocalPay,
    exact: true,
    key: 'local-pay',
    domain: 'finance',
  },
  {
    path: [
      ROUTES.QIWI_SUCCESS,
      ROUTES.QIWI_DECLINE,
      ROUTES.PAYMASTER_SERVICE_RESULT,
      ROUTES.PAYMENT_RESULT,
      ROUTES.BILLING_PAYMENT_RESULT,
      ROUTES.BILLING_TOP_UP_RESULT,
    ],
    component: () => <PaymentsReturnUrl />,
    key: 'payment_return_url',
    domain: 'finance',
  },
  {
    layout: 'wide',
    path: ROUTES.ADD_AGENCY,
    exact: true,
    key: 'agency/add-agency',
    icon: (
      <Icon
        name={'orders'}
        size={'m'}
      />
    ),
    label_key: 'agency::navigation.add-agency',
    component: AddAgency,
    domain: 'agency',
  },
  {
    layout: 'wide',
    path: ROUTES.AGENCY_ADD_CLIENT,
    exact: true,
    key: 'agency/add-client',
    icon: (
      <Icon
        name={'orders'}
        size={'m'}
      />
    ),
    label_key: 'agency::navigation.add-client',
    component: AddClient,
    domain: 'agency',
  },
  {
    path: ROUTES.TARGET_MAIL_CODE,
    component: () => <TargetMailCode />,
    key: 'target_mail_code_check',
  },
  {
    path: ROUTES.VK_CODE,
    component: () => <VkCode />,
    key: 'vk-code',
  },
  {
    path: ROUTES.ADSMARKET_CODE,
    component: () => <VkAdsMarketCode />,
    key: 'vk_code',
  },
  {
    path: ROUTES.VK_ADS_CODE,
    component: () => <VkAdsCode />,
    key: 'vk-ads-code',
  },
  {
    path: ROUTES.YANDEX_ADS_CODE,
    component: () => <YandexAdsCode />,
    key: 'yandex-ads-code',
  },
  {
    path: ROUTES.AUTOREPLENISH,
    exact: true,
    key: 'auto_replenish',
    label_key: 'common::nav_menu.auto_replenish',
    component: () => <AutoReplenish />,
    layout: 'wide',
    domain: 'services',
  },
  {
    path: ROUTES.SERVICES_NETWORK_ACCOUNT_MULTIREGISTER,
    exact: true,
    key: 'service_account_register_multilogin',
    label_key: 'common::nav_menu.network_account_register',
    component: () => <ServicesNetworkAccountCreate multiLogins />,
    layout: 'wide',
    restyled: true,
    domain: 'services',
  },
  {
    path: ROUTES.SERVICES_NETWORK_ACCOUNT_REGISTER,
    exact: true,
    key: 'service_account_register',
    label_key: 'common::nav_menu.network_account_register',
    component: ServicesNetworkAccountCreate,
    layout: 'wide',
    restyled: true,
    domain: 'services',
  },
  {
    restyled: true,
    path: ROUTES.SERVICES_NETWORK_ACCOUNT_ADVERTISER_INFO_EDIT,
    exact: true,
    key: 'service_network_account_tax_info_edit',
    label_key: 'common::nav_menu.network_account_tax_info_edit',
    component: ServicesNetworkAccountAdvertiserInfoEdit,
    layout: 'wide',
    domain: 'services',
  },
  {
    path: [ROUTES.SERVICES_NETWORK_ACCOUNT_ACCESS_NEW, ROUTES.SERVICES_NETWORK_ACCOUNT_ACCESS_EDIT],
    exact: true,
    key: 'service_network_account_access_create',
    label_key: 'common::nav_menu.network_access_create',
    component: ServicesNetworkAccountAccessCreate,
    layout: 'wide',
    domain: 'services',
  },
  {
    path: [ROUTES.REFERRAL_PAYOUT_PROFILE_NEW, ROUTES.REFERRAL_PAYOUT_PROFILE_EDIT],
    exact: true,
    key: 'referral/payout-profiles-new',
    label_key: 'referral::navigation.payout-profiles-new',
    page_title_keys: [
      'referral::navigation.referral_program',
      'referral::navigation.payout-profiles-new',
    ],
    component: PayoutProfilesCreate,
    layout: 'wide',
    domain: 'referral',
    icon: (
      <Icon
        name={'doc'}
        size={'m'}
      />
    ),
  },
  {
    path: ROUTES.SERVICES_NETWORK_ACCOUNT_REFUND,
    exact: true,
    key: 'service_network_account_refund',
    label_key: 'common::nav_menu.network_account_refund',
    component: ServicesNetworkAccountRefund,
    layout: 'wide',
    restyled: true,
    domain: 'services',
  },
  {
    exact: true,
    path: ROUTES.REFERRAL_PAYOUT,
    key: 'referral/payout',
    label_key: 'referral::navigation.payout',
    page_title_keys: ['referral::navigation.referral_program', 'referral::navigation.payout'],
    component: ReferralPayout,
    layout: 'wide',
    icon: (
      <Icon
        name={'user'}
        size={'m'}
      />
    ),
    domain: 'referral',
  },
  {
    path: ROUTES.SERVICES,
    exact: true,
    key: 'services_list',
    label_key: 'common::nav_menu.advertisement_networks',
    component: ServicesList,
    restyled: true,
    icon: (
      <Icon
        name={'gramophone'}
        size={'m'}
      />
    ),
    domain: 'services',
  },
  {
    path: ROUTES.SERVICES_NETWORK_ACCOUNT,
    exact: true,
    key: 'service_network_account',
    label_key: 'common::nav_menu.network_account',
    component: ServicesNetworkAccount,
    restyled: true,
    domain: 'services',
  },
  {
    restyled: true,
    path: ROUTES.SERVICES_NETWORK_ACCOUNT_ACCESS,
    exact: true,
    key: 'service_network_account_access_management',
    label_key: 'common::nav_menu.network_access_management',
    component: ServicesNetworkAccountAccess,
    domain: 'services',
  },
  {
    path: ROUTES.SERVICES_NETWORK_CAMPAIGNS_EDITOR_DEFAULT,
    exact: true,
    key: 'service_campaigns_editor',
    label_key: 'services::campaigns_editor.title',
    component: ServicesNetworkCampaignsEditorDefault,
    domain: 'services',
  },
  {
    path: ROUTES.SERVICES_NETWORK_CAMPAIGNS_EDITOR,
    key: 'service_campaigns_editor_resource',
    label_key: 'services::campaigns_editor.title',
    component: ServicesNetworkCampaignsEditor,
    domain: 'services',
  },
  {
    path: ROUTES.SERVICES_NETWORK_ACCOUNT_CAMPAIGNS,
    exact: true,
    key: 'service_network_account_campaigns',
    label_key: 'common::nav_menu.network_account_campaigns',
    component: ServicesNetworkAccountCampaigns,
    domain: 'services',
  },
  {
    path: ROUTES.SERVICES_NETWORK_ACCOUNT_CAMPAIGN_NEW,
    exact: true,
    key: 'service_network_account_campaign_create',
    label_key: 'common::nav_menu.network_account_campaign_create',
    component: ServicesNetworkAccountCampaignCreate,
    domain: 'services',
  },
  {
    path: ROUTES.SERVICES_NETWORK_ACCOUNT_CAMPAIGN_START,
    exact: true,
    key: 'service_network_account_campaign_start',
    label_key: 'common::nav_menu.network_account_campaign_start',
    component: ServicesNetworkAccountCampaignStart,
    domain: 'services',
  },
  {
    restyled: true,
    path: ROUTES.SERVICES_NETWORK_MEDIA_PLANNER,
    exact: true,
    key: 'service_media_planner_page',
    label_key: 'common::nav_menu.network_media_planner',
    component: ServicesNetworkMediaPlanner,
    domain: 'services',
  },
  // Keep static /services/:networkType/* routes (media-planner, campaigns-editor, …) above service_page.
  {
    path: ROUTES.SERVICES_NETWORK,
    exact: true,
    key: 'service_page',
    label_key: 'common::nav_menu.network',
    component: ServicesNetwork,
    restyled: true,
    domain: 'services',
  },
  {
    path: ROUTES.STATISTICS,
    exact: true,
    label_key: 'statistics::navigation.main',
    key: 'statistics_main',
    component: StatisticsMain,
    restyled: true,
    icon: (
      <Icon
        name={'statistics'}
        size={'m'}
      />
    ),
    domain: 'statistics',
  },
  {
    exact: true,

    path: ROUTES.STATISTICS_ACCOUNT,
    label_key: 'statistics::navigation.account',
    key: 'statistics_account',
    component: StatisticsAccount,
    domain: 'statistics',
  },
  {
    exact: true,

    path: ROUTES.STATISTICS_CAMPAIGN,
    label_key: 'statistics::navigation.campaign',
    key: 'statistics_campaign',
    component: StatisticsCampaign,
    domain: 'statistics',
  },
  // {
  //   path: ROUTES.STATISTICS_ACCOUNT_CONNECT,
  //   exact: true,
  //   label_key: 'statistics::navigation.account_connect',
  //   key: 'statistics_account_connect',
  //   component: StatisticsAccountConnect,
  // },
  {
    path: ROUTES.REFERRAL_LINKS_CREATE,
    exact: true,
    key: 'referral/links/create',
    label_key: 'referral::navigation.referral-links-create',
    page_title_keys: [
      'referral::navigation.affiliate_account',
      'referral::navigation.referral-links-create',
    ],
    component: ReferralLinksCreate,
    layout: 'wide',
    domain: 'referral',
  },
  {
    path: ROUTES.REFERRAL_LINKS_EDIT,
    exact: true,
    key: 'referral/links/edit',
    label_key: 'referral::navigation.referral-links-edit',
    page_title_keys: [
      'referral::navigation.affiliate_account',
      'referral::navigation.referral-links-edit',
    ],
    component: ReferralLinksEdit,
    layout: 'wide',
    domain: 'referral',
  },
  {
    path: ROUTES.REFERRAL_LINKS,
    exact: true,
    key: 'referral/links',
    icon: (
      <Icon
        name={'copy-link'}
        size={'m'}
      />
    ),
    label_key: 'referral::navigation.referral-links',
    page_title_keys: [
      'referral::navigation.affiliate_account',
      'referral::navigation.referral-links',
    ],
    component: ReferralLinks,
    domain: 'referral',
  },
  {
    exact: true,
    path: ROUTES.REFERRAL,
    key: 'referral/main',
    label_key: 'referral::navigation.referral',
    component: ReferralList,
    icon: (
      <Icon
        name={'user'}
        size={'m'}
      />
    ),
    domain: 'referral',
  },
  {
    exact: true,
    path: ROUTES.REFERRALS,
    key: 'referrals/main',
    label_key: 'referral::navigation.referrals',
    component: ReferralList,
    icon: (
      <Icon
        name={'user'}
        size={'m'}
      />
    ),
    domain: 'referral',
  },
  {
    path: ROUTES.REFERRAL_CLIENTS,
    exact: true,
    key: 'referral/referral-clients',
    icon: (
      <Icon
        name={'users'}
        size={'m'}
      />
    ),
    label_key: 'referral::navigation.referral-clients',
    page_title_keys: [
      'referral::navigation.affiliate_account',
      'referral::navigation.referral-clients',
    ],
    component: ReferralClients,
    restyled: true,
    domain: 'referral',
  },
  {
    exact: true,
    path: ROUTES.REFERRAL_PAYOUT_PROFILES,
    key: 'referral/payout-profiles',
    label_key: 'referral::navigation.payout-profiles',
    page_title_keys: [
      'referral::navigation.referral_program',
      'referral::navigation.payout-profiles',
    ],
    component: PayoutProfiles,
    icon: (
      <Icon
        name={'input'}
        size={'m'}
      />
    ),
    domain: 'referral',
  },
  {
    exact: true,
    path: ROUTES.REFERRAL_PAYOUT_PROFILE_INVOICES,
    key: 'referral/payouts-list',
    label_key: 'referral::navigation.payouts-list',
    page_title_keys: ['referral::navigation.referral_program', 'referral::navigation.payouts-list'],
    component: ReferralInvoices,
    icon: (
      <Icon
        name={'money'}
        size={'m'}
      />
    ),
    domain: 'referral',
  },

  //Пользовательские настройки
  {
    exact: true,
    restyled: true,
    path: ROUTES.USER_SETTINGS,
    key: 'user/settings',
    label_key: 'user::navigation.settings',
    component: Settings,
    icon: (
      <Icon
        name={'user'}
        size={'m'}
      />
    ),
    domain: 'user',
  },
  {
    exact: true,
    restyled: true,
    layout: 'wide',
    path: ROUTES.USER_SECURITY_PASSWORD,
    key: 'user/security/password',
    label_key: 'user::navigation.password',
    component: Password,
    domain: 'user',
  },
  {
    exact: true,
    restyled: true,
    layout: 'wide',
    path: ROUTES.USER_SECURITY_2FA,
    key: 'user/security/2fa',
    label_key: 'user::navigation.2fa',
    component: DoubleFA,
    domain: 'user',
  },

  {
    exact: true,
    restyled: true,
    layout: 'wide',
    path: ROUTES.USER_SECURITY_2FA_SETTING,
    key: 'user/security/2fa/setup',
    label_key: 'user::navigation.2fa',
    component: DoubleFASetup,
    domain: 'user',
  },

  // BILLING
  {
    layout: 'wide',
    exact: true,
    path: ROUTES.BILLING_TOP_UP,
    key: 'billing/top-up/deposit',
    label_key: 'billing::navigation.deposit',
    component: DepositReplenish,
    restyled: true,
    domain: 'finance',
  },
  {
    layout: 'wide',
    exact: true,
    path: ROUTES.BILLING_TOP_UP_ACCOUNT,
    key: 'billing/top-up/account',
    label_key: 'billing::navigation.account',
    component: AccountReplenish,
    restyled: true,
    domain: 'finance',
  },
  {
    layout: 'wide',
    exact: true,
    path: ROUTES.BILLING_TOP_UP_ACCOUNTS,
    key: 'billing/top-up/accounts',
    label_key: 'billing::navigation.deposit_accounts',
    component: AccountsReplenish,
    restyled: true,
    domain: 'finance',
  },
  {
    layout: 'wide',
    exact: true,
    path: ROUTES.BILLING_DEPOSIT_CREATION_FEE,
    key: 'billing/deposit-creation-fee',
    label_key: 'billing::navigation.deposit_creation_fee',
    component: DepositCreationFee,
    domain: 'finance',
  },
  {
    layout: 'wide',
    exact: true,
    path: ROUTES.BILLING_BANK_CARDS_TOP_UP,
    key: 'billing/bank-cards/top-up',
    label_key: 'billing::navigation.bank-cards.top-up',
    component: BankCardsReplenish,
    domain: 'finance',
    restyled: true,
  },
  {
    layout: 'wide',
    exact: true,
    path: ROUTES.BILLING_BANK_CARDS_CREATION_FEE,
    key: 'billing/bank-cards/create',
    label_key: 'billing::navigation.bank-cards.create',
    component: BankCardsCreationFee,
    domain: 'finance',
    restyled: true,
  },

  //FINANCE
  {
    exact: true,
    restyled: true,
    path: ROUTES.FINANCE_WALLETS,
    key: 'finance/wallets',
    label_key: 'finance::navigation.wallets',
    page_title_keys: ['finance::navigation.finance', 'finance::navigation.wallets'],
    component: WalletsRedirect,
    domain: 'finance',
    icon: (
      <Icon
        name={'money'}
        size={'m'}
      />
    ),
  },
  {
    exact: true,
    restyled: true,
    path: ROUTES.FINANCE_WALLET,
    key: 'finance/wallet',
    label_key: 'finance::navigation.wallets',
    page_title_keys: ['finance::navigation.finance', 'finance::navigation.wallets'],
    component: Wallets,
    domain: 'finance',
  },
  {
    exact: true,
    restyled: true,
    path: ROUTES.FINANCE_PAYMENT_PROFILES,
    key: 'finance/payment-profiles',
    label_key: 'finance::navigation.payment_profiles',
    page_title_keys: ['finance::navigation.finance', 'finance::navigation.payment_profiles'],
    component: PaymentProfiles,
    domain: 'finance',
    icon: (
      <Icon
        name={'user'}
        size={'m'}
      />
    ),
  },
  {
    exact: true,
    path: ROUTES.FINANCE_INVOICES,
    key: 'finance/invoices',
    label_key: 'finance::navigation.invoices',
    page_title_keys: ['finance::navigation.finance', 'finance::navigation.invoices'],
    component: Invoices,
    domain: 'finance',
    icon: (
      <Icon
        name={'doc'}
        size={'m'}
      />
    ),
  },
  {
    exact: true,
    path: ROUTES.FINANCE_PROMISED_PAYMENT,
    key: 'finance/promised-payment',
    label_key: 'finance::navigation.promised_payment',
    page_title_keys: ['finance::navigation.finance', 'finance::navigation.promised_payment'],
    component: PromisedPayment,
    domain: 'finance',
    icon: (
      <Icon
        name={'orders'}
        size={'m'}
      />
    ),
  },
  {
    path: ROUTES.FINANCE_PAYMENT_PROFILE_NEW,
    layout: 'wide',
    exact: true,
    restyled: true,
    key: 'finance/payment-profiles-new',
    label_key: 'payment_profiles::new.header_new',
    page_title_keys: ['finance::navigation.finance', 'payment_profiles::new.header_new'],
    component: PaymentProfilesCreate,
    icon: (
      <Icon
        name={'doc'}
        size={'m'}
      />
    ),
    domain: 'finance',
  },
  {
    path: ROUTES.FINANCE_PAYMENT_PROFILE_EDIT,
    layout: 'wide',
    exact: true,
    restyled: true,
    key: 'finance/payment-profiles-edit',
    label_key: 'finance::navigation.payment_profiles_edit',
    page_title_keys: ['finance::navigation.finance', 'finance::navigation.payment_profiles_edit'],
    component: PaymentProfilesCreate,
    icon: (
      <Icon
        name={'doc'}
        size={'m'}
      />
    ),
    domain: 'finance',
  },
  {
    exact: true,
    path: ROUTES.FINANCE_PROMISED_PAYMENT_REQUEST,
    key: 'finance/promised-payment-request',
    label_key: 'finance::navigation.promised_payment_request',
    page_title_keys: [
      'finance::navigation.finance',
      'finance::navigation.promised_payment_request',
    ],
    layout: 'wide',
    component: PromisedPaymentRequest,
    domain: 'finance',
  },
  {
    path: ROUTES.OAUTH_CODE,
    exact: true,
    label_key: 'common::nav_menu.oauth_code',
    key: 'oauth_code',
    component: OauthCode,
    domain: 'oauth',
  },
  {
    path: ROUTES.OAUTH_AUTH,
    exact: true,
    label_key: 'common::nav_menu.oauth_auth',
    key: 'oauth_auth',
    component: OauthAuth,
    domain: 'oauth',
  },

  //TICKETS
  {
    layout: 'custom',
    path: [ROUTES.TICKETS, ROUTES.TICKET_NEW, ROUTES.TICKET],
    exact: true,
    key: 'tickets/ticket',
    label_key: 'tickets::navigation.ticket_new',
    component: TicketOpener,
    domain: 'tickets',
  },

  //AGENCY
  {
    path: [ROUTES.AGENCY, ROUTES.AGENCY_CLIENTS, ROUTES.AGENCY_REQUESTS],
    exact: true,
    key: 'agency/cabinet',
    restyled: true,
    icon: (
      <Icon
        name={'profile'}
        size={'m'}
      />
    ),
    label_key: 'common::nav_menu.agency_dashboard',
    component: Agency,
    domain: 'agency',
  },
  {
    path: ROUTES.AGENCY_TRANSFER,
    exact: true,
    key: 'agency/transfer',
    icon: (
      <Icon
        name={'clients'}
        size={'m'}
      />
    ),
    label_key: 'agency::navigation.transfer',
    component: Transfer,
    domain: 'agency',
  },

  //Virtual Cards
  {
    path: ROUTES.BANK_CARDS_CREATE_CARD,
    exact: true,
    key: 'bank-cards/create-card',
    icon: (
      <Icon
        name={'card-cloud'}
        size={'m'}
      />
    ),
    label_key: 'bank_cards::navigation.bank_cards_create_card',
    page_title_keys: [
      'bank_cards::navigation.bank_cards',
      'bank_cards::navigation.bank_cards_create_card',
    ],
    component: BankCardsCreateCard,
    layout: 'wide',
    domain: 'bank-cards',
  },
  {
    path: ROUTES.BANK_CARDS_CARD,
    exact: true,
    key: 'virtual-cards-card',
    restyled: true,
    icon: (
      <Icon
        name={'card-cloud'}
        size={'m'}
      />
    ),
    label_key: 'bank_cards::navigation.bank_cards_card',
    component: BankCardsCard,
    domain: 'bank-cards',
  },
  {
    path: ROUTES.BANK_CARDS,
    restyled: true,
    exact: true,
    key: 'virtual-cards',
    icon: (
      <Icon
        name={'card-cloud'}
        size={'m'}
      />
    ),
    label_key: 'bank_cards::navigation.bank_cards',
    component: BankCards,
    domain: 'bank-cards',
  },
  {
    exact: true,
    path: ROUTES.CABINET_FAQ_ARTICLE,
    key: 'faq/category_article',
    label_key: 'faq::navigation.category_article',
    restyled: true,
    component: FaqArticle,
    domain: 'faq',
    layout: 'faq-main',
  },
  {
    exact: true,
    path: ROUTES.CABINET_FAQ_CATEGORY,
    key: 'faq/category',
    label_key: 'faq::navigation.category',
    restyled: true,
    component: FaqCategory,
    domain: 'faq',
    layout: 'faq-main',
  },
  {
    exact: true,
    path: ROUTES.CABINET_FAQ,
    key: 'faq/categories',
    label_key: 'faq::navigation.categories',
    restyled: true,
    component: FaqCategories,
    domain: 'faq',
    layout: 'faq-wide',
  },
]

const routes = [
  ...withAccess(publicRoutesList, ROUTE_ACCESS.PUBLIC),
  ...withAccess(guestRoutesList, ROUTE_ACCESS.GUEST),
  ...withAccess(privateRoutesList, ROUTE_ACCESS.PRIVATE),
]

export { routes, withAccess, ROUTE_ACCESS }
